<template lang="html">

       <div class="contenedor-imagen" :style="`background-position:${leftpos}% ${toppos}%`">
         <div class="contenedor-flechas">
          <span class="flecha" @click="right" :hide="leftpos == 100"></span>
          <span class="flecha" @click="bottom" :hide="toppos == 100"></span>
          <span class="flecha" @click="left" :hide="leftpos == 0"></span>
          <span class="flecha" @click="top" :hide="toppos == 0"></span>
        </div>
      </div>

</template>

<script lang="js">
  export default  {
    name: 'tour-bodega',
    props: [],
    mounted() {

    },
    data() {
      return {
        toppos:50,
        leftpos:50
      }
    },
    methods: {
      bottom : function(){
          if(this.toppos < 100){
          this.toppos += 10;
        }
      },
     right : function(){
           if(this.leftpos < 100){
          this.leftpos += 10;
        }
      },
      left : function(){
               if(this.leftpos > 0){
          this.leftpos -= 10;
        }
      },
      top : function(){
           if(this.toppos > 0){
          this.toppos += -10;
        }
      },
    },
    
}
</script>

<style scoped lang="scss">
  .flecha{
    transition: .5s;
    transition-delay: 0s;
    cursor: pointer;
  }
  .flecha[hide="true"]{
    opacity: 0;

  }
</style>



// WEBPACK FOOTER //
// src/components/views/experiencias/tour-bodega.vue